import React from 'react'
import { Radio } from 'atoms/Radio'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './deviceSettings__webRTC.jcss'
import { Typography } from 'atoms/Typography'

const DeviceSettingsWebRTC = (p_: {
    enabled: boolean
    className: string | object
    value: string
    onChange: (value: any, field: string) => void
}) => {
    if (!p_.enabled) {
        return null
    }

    return (
        <div className={cn(p_.className)}>
            <Typography className={cn(styles.title)} type="title">
                {translate('remoteControlWebRTC')}
            </Typography>
            <div className={styles.radioWrapper}>
                <Radio
                    className={styles.radio}
                    onClick={function () {
                        p_.onChange('on', 'useWebRTC')
                    }}
                    selected={p_.value === 'on'}
                    label={translate('on')}
                />
                <Radio
                    className={styles.radio}
                    onClick={function () {
                        p_.onChange('off', 'useWebRTC')
                    }}
                    selected={p_.value === 'off'}
                    label={translate('off')}
                />
                <Radio
                    onClick={function () {
                        p_.onChange('default', 'useWebRTC')
                    }}
                    selected={p_.value === 'default'}
                    label={translate('useBuildConfig')}
                />
            </div>
            <div className={styles.hint}>{translate('remoteControlWebRTCRebootTip')}</div>
        </div>
    )
}

export default React.memo(DeviceSettingsWebRTC)
